import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const ListarParametros = () => {
    return axios.get(`${API_URL}/administrar/parametros`, {
        headers: getHeaders(),
    });
};
/* Selector de parametros segun el tipo */
export const obtenerParametrosPorTipos = async (codigo_tipo_parametro) => {
    try {
        const resp = await axios.get(
            `${API_URL}/administrar/parametros/${codigo_tipo_parametro}`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const crearOEditarParametro = async (parametro) => {
    const configs = { headers: getHeaders() };

    try {
        if (parametro.id !== "") {
            const resp = await axios.put(
                `${API_URL}/administrar/parametros/${parametro.id}`,
                parametro,
                configs
            );
            return resp.data;
        }

        const resp = await axios.post(
            `${API_URL}/administrar/parametros`,
            parametro,
            configs
        );
        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const inactivarParametro = async (id_parametro) => {
    try {
        const resp = await axios.delete(
            `${API_URL}/administrar/parametros/${id_parametro}`,
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const activarParametro = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/administrar/parametros/activar/${data.id}`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
